import { CompanyTitledPage } from "../TitledPage";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import Button from "@mui/material/Button";

import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CompanyPartHeader } from "../../components/PartHeader";
import useInputObject from "../../hooks/useInputObject";
import { getVar, insertVar, updateVar } from "../../http/api/VarAPI";
import VarInfo from "./VarInfo";

const infoTableCellSx = {
  fontSize: 18,
};

// 新規変数更新ページ
const VarInsertPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { varDiv } = location.state;

  const varInfo = useInputObject({});

  // 変数取得
  useEffect(() => {
    if (varDiv != null) {
      varInfo.setValue({ varDiv });
    }
  }, [varDiv]);

  const handleClickReturn = (event) => {
    navigate(-1);
  };

  // 登録ボタンをクリックするイベント
  async function handleClickUpdate() {
    try {
      let insertItem = varInfo.Value;
      insertItem.createdId = 1; //TODO JWTを追加した後削除
      insertItem.updatedId = 1; //TODO JWTを追加した後削除
      let response = await insertVar(insertItem);
      alert("変数を登録しました。");
      navigate("/company/var", {
        state: { varDiv },
      });
    } catch {
      alert("変数を登録できませんでした。");
    }
  }

  return (
    <CompanyTitledPage title="変数登録">
      <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              変数情報の入力
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button variant="contained" onClick={handleClickUpdate}>
              登録
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" onClick={handleClickReturn}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>
      {/* 変数情報 */}
      <VarInfo varInfo={varInfo} isUpdateMode={false} />
    </CompanyTitledPage>
  );
};
export default VarInsertPage;
